import React from 'react';

type Props = {
  text: string;
  onMouseDown: () => void;
};

const SuggestedUserName = ({ onMouseDown, text }: Props) => {
  return (
    <div
      className="border font-medium hover:bg-gray-100 hover:dark:bg-black-950 border-light-input-border cursor-pointer dark:border-dark-input-border rounded-lg py-2 px-4 text-light-text-primary dark:text-dark-text-primary"
      onMouseDown={() => onMouseDown()}
    >
      {text}
    </div>
  );
};

export default SuggestedUserName;
